// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f78f3e7d","58":"9c74912d","284":"e30c817e","341":"94e8379d","541":"65891249","702":"8f54e63d","783":"07fab473","872":"5d83ca8e","995":"2070b316"}[chunkId] + ".chunk.js";
};